import React, { useState } from "react";
import { UI_Modal, UI_Modal_OTP } from "../../UiComponents/index";
import "./FP.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CgSpinner } from "react-icons/cg";

function VerifyOTPModal(props) {
  const {
    isOtpSuccess,
    setIsOtpSuccess,
    otp,
    setOpt,
    handleSubmitOtp,
    handleResendOtp,
    password,
    setPassword,
    confirmPassword,
    setconfirmPassword,
    inValid,
    submitSuccessLoading,
  } = props;
  const [showPassword, setShowPassword] = useState(false);

  // Ensure OTP is always an array of 6 characters
  const otpArray = otp
    ? otp.split("").concat(Array(6 - otp.length).fill(""))
    : Array(6).fill("");

  // Handle OTP change
  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/, ""); // Allow only numbers

    const newOtp = [...otpArray]; // Clone OTP array
    newOtp[index] = value; // Update digit

    setOpt(newOtp.join("")); // Update state

    // Move focus to the next field if a digit is entered
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  // Handle backspace
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otpArray];
      newOtp[index] = ""; // Clear current input
      setOpt(newOtp.join("")); // Update state

      // Move focus to the previous field if current field is empty
      if (index > 0) {
        document.getElementById(`otp-${index - 1}`).focus();
      }
    }
  };

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7 flex justify-center cursor-pointer not-italic"
      onClick={closeToast}
    >
      ✖
    </i>
  );

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <ToastContainer closeButton={CloseButton} />

      <UI_Modal_OTP
        isOpen={isOtpSuccess}
        closeModal={() => {
          setIsOtpSuccess(false);
          localStorage.clear();
        }}
        title="Forgot Password"
      >
        <div className="w-full">
          <div className=" pt-[20px] items-start text-white">
            <div className="basis-1/6 FontFamily-Avenir-reg text-base">
              <h2>One Time Password</h2>
            </div>
            <div className="flex justify-between items-center pt-[15px]">
              {otpArray.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="tel"
                  // className="w-full  p-1 input_block input_blockFP"
                  className="otp_input text-center"
                  maxLength="1"
                  // value={otp}
                  value={digit}
                  // onChange={(e) => setOpt(e.target.value)}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  // onInput={(e) => {
                  //     e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 6)
                  // }}

                  autoComplete="one-time-code"
                  inputMode="numeric"
                  placeholder=""
                />
              ))}
            </div>
            {/* <p className='inValidOtpFP'>{inValid ? inValid : null}</p> */}
            {inValid && <p className="text-red-500 mt-2">{inValid}</p>}
          </div>

          <div className="  pt-[20px]  items-start text-white">
            <div className="basis-1/6  FontFamily-Avenir-reg text-base">
              <h2>New Password</h2>
            </div>
            <div className="basis-3/4  pt-[15px] relative">
              <input
                type={showPassword ? "text" : "password"}
                className="w-full input_blockFP text-white"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <div
                className="w-5 h-5 cursor-pointer text-white absolute right-[10px] top-[30px]"
                onClick={handleShowPassword}
              >
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </div>
            </div>
          </div>

          <div className="  pt-[20px]  items-start text-white">
            <div className="basis-1/6 FontFamily-Avenir-reg text-base">
              <h2>Confirm New Password</h2>
            </div>
            <div className="basis-3/4 pt-[15px]">
              <input
                type="password"
                className="w-full input_blockFP"
                value={confirmPassword}
                onChange={(e) => setconfirmPassword(e.target.value)}
              />
            </div>
          </div>

          <div className=" pt-[20px] flex justify-center items-center FontFamily-Avenir">
            <button
              className="cancel_btn_ui text-lg ml-[-10px] mr-[20px]"
              onClick={handleResendOtp}
            >
              Resend Code
            </button>
            <button className="submit_btn_ui text-lg flex items-center justify-center gap-4 relative" onClick={handleSubmitOtp}>
              Confirm
              {submitSuccessLoading && (
                <CgSpinner className="animate-spin text-[1.1rem]" />
              )}
            </button>
          </div>
        </div>
      </UI_Modal_OTP>
    </>
  );
}

export default VerifyOTPModal;
